import { CURRENCIES } from "../../lib/currency";
import { quoteParamsError } from "../../lib/quoteParams";

/**
 * WizardParams — bottom row of inputs (batch, margin, currency, customer)
 * plus the notes textarea. Extracted from Step3MachinesPanel.
 */
export default function WizardParams({
  t,
  batchSize,
  setBatchSize,
  marginPct,
  setMarginPct,
  currency,
  setCurrency,
  customers,
  customerId,
  setCustomerId,
  notes,
  setNotes,
}) {
  const paramsError = quoteParamsError(batchSize, marginPct, t);
  return (
    <>
      <div className="grid grid-cols-2 gap-4 mt-6 pt-6 border-t border-slate-800">
        <div>
          <label className="label-tech block mb-2">{t("newQuote.batchLabel")}</label>
          <input
            type="number"
            min="1"
            value={batchSize}
            onChange={(e) => setBatchSize(e.target.value)}
            className="w-full px-4 py-3 rounded-md text-sm"
            data-testid="batch-size-input"
          />
        </div>
        <div>
          <label className="label-tech block mb-2">{t("newQuote.marginLabel")}</label>
          <input
            type="number"
            min="0"
            max="200"
            value={marginPct}
            onChange={(e) => setMarginPct(e.target.value)}
            className="w-full px-4 py-3 rounded-md text-sm"
            data-testid="margin-input"
          />
        </div>
        {paramsError && (
          <div className="col-span-2 text-sm text-red-400" data-testid="params-error">{paramsError}</div>
        )}
        <div>
          <label className="label-tech block mb-2">{t("newQuote.currencyLabel")}</label>
          <select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className="w-full px-4 py-3 rounded-md text-sm"
            data-testid="currency-select"
          >
            {CURRENCIES.map((c) => (
              <option key={c.code} value={c.code}>
                {c.code} ({c.symbol}) — {c.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="label-tech block mb-2">{t("newQuote.customerLabel")}</label>
          <select
            value={customerId}
            onChange={(e) => setCustomerId(e.target.value)}
            className="w-full px-4 py-3 rounded-md text-sm"
            data-testid="customer-select"
          >
            <option value="">{t("newQuote.noCustomer")}</option>
            {customers.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="mt-4">
        <label className="label-tech block mb-2">{t("newQuote.notesLabel")}</label>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={2}
          className="w-full px-4 py-3 rounded-md text-sm"
          placeholder={t("newQuote.notesPlaceholder")}
          data-testid="notes-input"
        />
      </div>
    </>
  );
}
